export enum IdentificationMethod {
    WITH_IDENTITY_PROVIDER = 'with-identity-provider',
    WITHOUT_IDENTITY_PROVIDER = 'without-identity-provider'
}